import React, {useEffect, useMemo} from 'react';
import FormInput from "../../../../common/FormInput";
import {t} from "../../../../../services/i18n";
import AdvanceSelect from "../../../../common/AdvanceSelect";
import {APPOINTMENT, CATEGORY_SELECT} from "../../../../../services/ConstHelper";
import {getSessionTypeIdByName, isMobile} from "../../../../../services/Helpers";
import {useDispatch, useSelector} from "react-redux";
import {getCategoriesByTypes} from "../../../../../redux/ScheduleSlice";

const ServiceSelection = (props) => {
    const { values, setFieldValue, errors, touched } = props;
    const services = useSelector(state => state.schedule.eventTypes.data)
    const categoryTypeId = useMemo(() => getSessionTypeIdByName(APPOINTMENT), [services])
    const options = useMemo(() => services ? services[APPOINTMENT].filter(item => !!item.active).reduce((acc, item) => [...acc, {...item, value: item.id, label: item.name}], []) : [], [services])
    const dispatch = useDispatch()

    useEffect(() => {
        if(!services) dispatch(getCategoriesByTypes(true))
    }, [services]);

    return (
        <div>
            <FormInput
                width={'100%'}
                containerProps={{mb: '1rem'}}
                label={t('service-name')}
                infoTooltip={isMobile ? null : t('service-name-tooltip')}
                error={(touched.val && errors.val) ? errors.val : null}>
                <AdvanceSelect options={options ?? []}
                               type={CATEGORY_SELECT}
                               categoryTypeId={categoryTypeId}
                               onChange={(val) => setFieldValue('val', val?.id ?? null)}
                               initValue={values.val}
                               isError={errors.val && touched.val}/>
            </FormInput>
        </div>
    );
};

export default ServiceSelection;